import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagPuntoVentaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagPuntoVenta'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagPuntoVenta'
          label='Punto venta'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagPuntoVentaFormGroup)
